/**
 * 页面的信息
 */
interface IPageInfo {
    path: string;
    hash: string;
    title: string;
}

/**
 * 当前的序列
 */
interface ISeqInfo {
    pageId: number;
    seq: number;
}

const STAY_EVENT_ID = 'pub_stay_time_bt';
/**
 * 属性
 * - http://omega.xiaojukeji.com/ba/point/detail?pointId=1112733#tab=pointattr
 */
interface IStayAttrs {
    /**
     * page id
     */
    id: number;
    /**
     * page hash
     */
    ph: string;
    /**
     * page title
     */
    pt: string;
    /**
     * page url
     */
    pu: string;
    /**
     * seq
     */
    s: number;
    /**
     * active time
     */
    ta: number;
    /**
     * live time
     */
    tl: number;
}

/**
 * 页面的时间插件
 * - 可过去当前页面的打开时间
 * - 可活动时长
 */
export default class PageStayTime {
    /**
     * 页面是否隐藏中
     */
    private pageHidding: boolean = false;
    /**
     * 是否开始心跳上报
     */
    private isStart: boolean = false;
    /**
     * 当前页面的信息
     */
    private pageInfo: IPageInfo = {
        path: '',
        hash: '',
        title: ''
    };
    /**
     * 当前上报的序列
     */
    private seqInfo: ISeqInfo = {
        pageId: 0,
        seq: 0
    };
    /**
     * 当前页面第一次pageview的时间
     */
    private startTime: number = 0;
    /**
     * 页面hide的时间
     */
    private pageHideTime: number = 0;

    /**
     * 触发hide的时间
     */
    private startHideTime: number = 0;

    /**
     * 当前上报的数据
     */
    private reportTimeId: any;
    /**
     * 上报
     */
    private report(eventId: string, eventLabel?: any, attrs?: any): Promise<void> {
        return Promise.resolve();
    }

    constructor(props: any) {
        this.report = props.report;
    }
    /**
     * 开启停留时长
     */
    public start() {
        // 已经开始，上报最后一条信息
        if (this.isStart) {
            this.reportHeart();
        } else {
            // 第一次开始需要进行页面的监控
            this.addPageVisibilityChange();
            this.isStart = true;
        }
        this.init();
        // 自增pageId
        this.inCreasePageId();
        // 开启定时上报
        this.startTimeReport();
    }
    /**
     * 进行page的隐藏事件监听
     */
    private addPageVisibilityChange() {
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                this.onPageInHide();
            } else {
                this.onPageShow();
            }
        }, false);
    }
    /**
     * 当页面进入hide
     */
    private onPageInHide() {
        this.pageHidding = true;
        this.startHideTime = new Date().getTime();
        this.stopTimeoutReport();
    }
    /**
     * 页面展示触发
     */
    private onPageShow() {
        this.pageHidding = false;
        // 不存在开始隐藏时间
        if (this.startHideTime !== 0) {
            this.pageHideTime += (new Date().getTime() - this.startHideTime);
        } else {
            this.pageHideTime = 0;
        }
        /**
         * 直接上报一个心跳
         */
        this.reportHeart();
        /**
         * 开始自动上报
         */
        this.startTimeReport();
    }
    /**
     * 停止定时上报
     */
    private stopTimeoutReport() {
        if (this.reportTimeId) {
            clearTimeout(this.reportTimeId);
            this.reportTimeId = undefined;
        }
    }
    /**
     * 重置信息
     */
    private init = () => {
        // url的信息
        this.initUrlInfo();
        // 初始化时间
        this.initTime();
        // 初始化页面的状态
        this.initPageStatus();
    }
    /**
     * 页面状态
     */
    private initPageStatus = () => {
        if (document.hidden || document.visibilityState === 'hidden') {
            this.onPageInHide();
        }
    }
    /**
     * 进行url的信息获取
     */
    private initUrlInfo() {
        const path = `${location.host}${location.pathname}`;
        const hash = `${location.hash}`;
        const title = document.title;
        this.pageInfo = {
            path,
            hash,
            title
        };
    }
    /**
     * 重新设置时间
     * - 重置开始时间
     * - 重置隐藏时间
     * - 设置进入隐藏的时间
     */
    private initTime() {
        this.startTime = new Date().getTime();
        this.pageHideTime = 0;
        this.startHideTime = 0;
    }
    /**
     * 进行pageId自增
     */
    private inCreasePageId() {
        const pageId = this.seqInfo.pageId + 1;
        this.seqInfo = {
            pageId,
            seq: 0
        };
    }

    /**
     * 开始定时上报
     * - 每2s进行上报
     */
    private startTimeReport() {
        if (this.reportTimeId) {
            clearTimeout(this.reportTimeId);
            this.reportTimeId = undefined;
        }
        // 当页面为隐藏状态则不进行定时上报
        if (this.pageHidding) {
            return;
        }
        this.reportTimeId = setTimeout(() => {
            this.reportHeart();
            this.startTimeReport();
        }, 2 * 1000);
    }

    /**
     * 上报心跳
     */
    private reportHeart() {
        const now = new Date().getTime();
        /**
         * 存活时长保留一位小数
         */
        const liveTime = Math.round(( now - this.startTime) / 100) / 10;
        /**
         * 活跃时长保留一位小数
         */
        const activeTime = Math.round((now - this.startTime - this.pageHideTime) / 100) / 10;
        /**
         * seq自增
         */
        this.seqInfo.seq += 1;
        const attrs: IStayAttrs = {
            id: this.seqInfo.pageId,
            s: this.seqInfo.seq,
            tl: liveTime,
            ta: activeTime,
            ph: this.pageInfo.hash,
            pt: this.pageInfo.title,
            pu: this.pageInfo.path
        };
        this.report(STAY_EVENT_ID, attrs);
    }
}
